import { render, staticRenderFns } from "./PacienteInformacion.vue?vue&type=template&id=205cf24d&"
import script from "./PacienteInformacion.vue?vue&type=script&lang=js&"
export * from "./PacienteInformacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports